import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
import { useDb } from '../../../hooks/useDb';
import { contactById, mailsFrom } from '../../../utils/dbSelectors';
import { getAgent } from '../../../utils/agents';
import { euro } from '../../../utils/time';
const USE_TARGETS = ['Landingspagina project X', 'Figma: Landingspagina', 'Downloaden'];
export function RenderBody({
  onUse
}: {
  onUse: (target: string) => void;
}) {
  const render = useDb(t => t.renders[0]);
  const [menu, setMenu] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!menu) return;
    const close = (e: PointerEvent) => ref.current && !ref.current.contains(e.target as Node) && setMenu(false);
    document.addEventListener('pointerdown', close);
    return () => document.removeEventListener('pointerdown', close);
  }, [menu]);
  return <div className="grid gap-5 xl:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)]" data-id="element-559" data-mp="1v3isgzhla2e2">
      <img src={render.image} alt="Gegenereerd beeld: betonnen interieur in de schemering met zacht teal licht" className="aspect-video w-full rounded-2xl object-cover" data-id="element-560" data-mp="otwckup9wjfi" />
      <div className="flex flex-col" data-id="element-561" data-mp="evgo6zhmro9p">
        <p className="text-[13px] font-medium text-ink-muted" data-id="element-562" data-mp="eykx2a61j86p">Prompt</p>
        <p className="mt-1 text-ink" data-id="element-563" data-mp="au4vgl3gmmxa">{render.prompt}</p>
        <dl className="mt-4 grid grid-cols-[90px_1fr] gap-y-1 text-[14px]" data-id="element-564" data-mp="5vjtoh8k7v6q">
          <dt className="text-ink-muted" data-id="element-565" data-mp="5xmt1rvlr0o4">Model</dt>
          <dd className="text-ink" data-id="element-566" data-mp="14204e8v8wvs">{render.model}</dd>
          <dt className="text-ink-muted" data-id="element-567" data-mp="3sbe8c3rrtzzk">Rendertijd</dt>
          <dd className="text-ink" data-id="element-568" data-mp="3sc62da5pzpnq">{render.seconds} s op het GPU-brein</dd>
        </dl>
        <div ref={ref} className="relative mt-auto pt-5" data-id="element-569" data-mp="3ndcpnjy9c2om">
          <button type="button" aria-expanded={menu} onClick={() => setMenu(m => !m)} className="flex h-11 w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-ink text-[14px] font-semibold text-night-950 transition-colors duration-150 hover:bg-white" data-id="element-570" data-mp="3jaq420s6jdzv">
            Gebruiken in… <ChevronDownIcon className="h-4 w-4" aria-hidden data-id="element-571" data-mp="38qe4g6pzu4ic" />
          </button>
          <AnimatePresence data-id="element-572" data-mp="2uqv625mzi7j8">
            {menu && <motion.ul initial={{
            opacity: 0,
            y: 4,
            scale: 0.97
          }} animate={{
            opacity: 1,
            y: 0,
            scale: 1
          }} exit={{
            opacity: 0,
            y: 4,
            scale: 0.97
          }} transition={{
            duration: 0.16,
            ease: [0.23, 1, 0.32, 1]
          }} className="absolute bottom-full left-0 right-0 z-10 mb-2 origin-bottom rounded-2xl border border-white/10 bg-night-900 p-1.5" data-id="element-573" data-mp="2us6am7o97jbe">
                {USE_TARGETS.map(t => <li key={t} data-id="element-574" data-mp="3ilxw2gxiyh1a">
                    <button type="button" onClick={() => {
                setMenu(false);
                onUse(t);
              }} className="w-full rounded-xl px-3 py-2.5 text-left text-[14px] text-ink transition-colors duration-150 hover:bg-white/[0.06]" data-id="element-575" data-mp="a7z2tn1xt9rh">
                      {t}
                    </button>
                  </li>)}
              </motion.ul>}
          </AnimatePresence>
        </div>
      </div>
    </div>;
}
export function LisaBody() {
  const {
    lisa,
    mails
  } = useDb(t => ({
    lisa: contactById(t, 'lisa'),
    mails: mailsFrom(t, 'lisa').slice(-2)
  }));
  if (!lisa) return null;
  return <div className="grid gap-5 md:grid-cols-3" data-id="element-576" data-mp="1bsq73veammyu">
      <div data-id="element-577" data-mp="1pqojwwcyubc8">
        <p className="text-[13px] font-medium text-ink-muted" data-id="element-578" data-mp="1prg5rfgrgupb">{lisa.company}</p>
        <ul className="mt-1 space-y-1 text-ink" data-id="element-579" data-mp="1krtsx74uhgh1">
          {lisa.about.map(l => <li key={l} data-id="element-580" data-mp="1ku6j27krax56">{l}</li>)}
        </ul>
      </div>
      <div data-id="element-581" data-mp="314ike4zava6u">
        <p className="text-[13px] font-medium text-ink-muted" data-id="element-582" data-mp="3148v6jm2x727">Laatste mails</p>
        <ul className="mt-1 space-y-2" data-id="element-583" data-mp="2w67c3yonl7qq">
          {mails.map(m => <li key={m.id} data-id="element-584" data-mp="3rhp2ogurizql">
              <p className="text-ink" data-id="element-585" data-mp="3rigsfb1oi38y">{m.subject}</p>
              <p className="text-[13px] text-ink-muted" data-id="element-586" data-mp="am7lebt09b3">{m.received}</p>
            </li>)}
        </ul>
      </div>
      <div data-id="element-587" data-mp="59pbuwjymbi0">
        <p className="text-[13px] font-medium text-ink-muted" data-id="element-588" data-mp="595v3j61pt5k">Open vraag</p>
        <p className="mt-1 text-ink" data-id="element-589" data-mp="a9la0f5z78pn">{lisa.openQuestion}</p>
      </div>
    </div>;
}
export function KostenBody() {
  const {
    rows,
    cloud
  } = useDb(t => ({
    rows: t.cloudCostByAgent,
    cloud: t.meta.cloud
  }));
  const max = Math.max(...rows.map(r => r.euro));
  return <div data-id="element-590" data-mp="o0gi3p8nhls6">
      <p className="font-display text-[34px] font-extralight tabular-nums text-ink" data-id="element-591" data-mp="o0qdjscgsl59">
        {euro(cloud.spent)} <span className="text-[16px] text-ink-muted" data-id="element-592" data-mp="t02xa481hc3m">van {euro(cloud.budget)} vandaag</span>
      </p>
      <ul className="mt-4 space-y-2.5" data-id="element-593" data-mp="xz62boo0ribl">
        {rows.map((r, i) => {
        const a = getAgent(r.agent);
        return <li key={r.agent} className="grid grid-cols-[96px_1fr_64px] items-center gap-3" data-id="element-594" data-mp="12110ikanlfl5" data-mpi={i}>
              <span className="text-ink" data-id="element-595" data-mp="2mj1silzdasfk">{a.name}</span>
              <span className="h-2 overflow-hidden rounded-full bg-white/[0.06]" data-id="element-596" data-mp="2igx2dx84odxo">
                <motion.span className="block h-full rounded-full" style={{
              backgroundColor: a.color
            }} initial={{
              width: 0
            }} animate={{
              width: `${r.euro / max * 100}%`
            }} transition={{
              duration: 0.3,
              delay: i * 0.05,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-597" data-mp="2ij1ev3k3el9k" />
              </span>
              <span className="text-right tabular-nums text-ink-soft" data-id="element-598" data-mp="317yapbv51ltw">{euro(r.euro)}</span>
            </li>;
      })}
      </ul>
      {cloud.localOnly && <p className="mt-4 flex items-center gap-2 text-amber" data-id="element-599" data-mp="2rgbsuwoaooi6">
          <CheckIcon className="h-4 w-4" aria-hidden data-id="element-600" data-mp="3owr2cw4q97ip" /> Rest van de dag alleen lokale modellen.
        </p>}
    </div>;
}